import { render, staticRenderFns } from "./ModalAssignLocationProducts.vue?vue&type=template&id=57787bbf&scoped=true"
import script from "./ModalAssignLocationProducts.vue?vue&type=script&lang=js"
export * from "./ModalAssignLocationProducts.vue?vue&type=script&lang=js"
import style1 from "@riophae/vue-treeselect/dist/vue-treeselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57787bbf",
  null
  
)

export default component.exports